import { type CountryCode, isValidNumberForRegion } from "libphonenumber-js";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import { PhoneInput } from "@/components/ui/phone-input";

import { type FormControlProps } from "./types";

export const PhoneFormControl = ({
  field,
  name,
  countryCode,
}: FormControlProps) => {
  const { t } = useTranslation();
  const { control } = useFormContext();

  return (
    <FormField
      control={control}
      name={name}
      rules={{
        validate: (value: string) =>
          isValidNumberForRegion(value, countryCode as CountryCode) ||
          t("error_invalidPhone"),
      }}
      render={(context) => (
        <FormItem>
          <FormLabel>{field.title}</FormLabel>
          <FormControl>
            <PhoneInput
              data-test-id="form-phone"
              placeholder={field.title}
              defaultCountry={countryCode as CountryCode}
              {...context.field}
            />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};
